import { MantineThemeOverride } from '@mantine/core';

export type TypographyStylesProviderTheme = NonNullable<MantineThemeOverride['components']>['TypographyStylesProvider'];

export const TypographyStylesProvider: TypographyStylesProviderTheme = {
  // todo: define
};
